import UserInfo from "../User/UserInfo";

class LicenceAssign {
  constructor(data) {
    if (data) {
      this.User = new UserInfo(data.User);
      this.NoOflicensesAssigned = data.NoOflicensesAssigned;
      this.ProductId = data.ProductId;
      this.AssignedByUserId = data.AssignedByUserId;
      this.id = data.id;
    } else {
      this.User = new UserInfo(null);
      this.NoOflicensesAssigned = null;
      this.ProductId = null;
      this.AssignedByUserId = null;
      this.id = null;
    }
  }
}

export default LicenceAssign;
